<template>
  <div
    class="modal fade"
    id="otherRequirementModal"
    tabindex="-1"
    aria-labelledby="otherRequirementModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="otherRequirementModalLabel">
            ¿Necesitas un diagnóstico?
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="other-requirement__note">
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Provident
            quia minus, velit possimus odio molestiae nobis voluptas quisquam,
            aspernatur autem voluptatibus? Tenetur magnam fugit, quibusdam
            assumenda neque exercitationem inventore illo.
          </div>
          <textarea
            name="other_requirements"
            id="other_requirements"
            cols="30"
            rows="10"
            placeholder="Escribe tu requerimiento..."
            v-model="otherRequirement"
          ></textarea>
        </div>
        <div class="modal-footer justify-content-between">
          <button
            type="button"
            class="btn btn--outline"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
          <div class="d-flex justify-content-end gap-3">
            <button
              type="button"
              class="btn"
              @click.prevent="sendOtherRequirementByEmail()"
            >
              Enviar consulta
            </button>
            <button
              type="button"
              class="btn"
              @click.prevent="sendOtherRequirement"
            >
              Agendar cita
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <profile-vehicle-modal
    :brands="props.brands"
    :url_store="props.urls.vehicleStore"
    :url_get_vehicle_models="props.urls.getVehicleModels"
    :url_get_vehicle_versions="props.urls.getVehicleVersions"
  />
</template>

<script setup>
import axios from 'axios'
import { onMounted, ref } from 'vue'
import { customAlert } from '../../../general/js/utils/swalMessages'

const props = defineProps({
  brands: {
    type: Array,
    default: () => [],
  },
  urls: {
    type: Object,
  },
  userId: {
    type: Number,
  },
})

const otherRequirement = ref('')

onMounted(() => {
  const otherRequirementLocalStorage = localStorage.getItem('otherRequirement')

  if (otherRequirementLocalStorage && props.userId !== 0) {
    otherRequirement.value = otherRequirementLocalStorage

    window.addEventListener('load', () => {
      $('#otherRequirementModal').modal('show')
      sendOtherRequirementByEmail()
    })
  }
})

const sendOtherRequirementByEmail = async () => {
  if (props.userId === 0) {
    const data = {
      type: 2,
      title: '¡Ups!',
      subtitle: 'Debes iniciar sesión para enviar un requerimiento.',
    }

    localStorage.setItem('otherRequirement', otherRequirement.value)
    customAlert(data)
    window.location.href = props.urls.register
    return false
  }

  try {
    const { data } = await axios.get(props.urls.userHasVehicle, {
      params: {
        userId: props.userId,
      },
    })

    if (!data) {
      const data = {
        type: 2,
        title: '¡Ups!',
        subtitle: 'No tienes un vehículo registrado.',
      }

      customAlert(data)
      $('#addVehicleModal').modal('show')

      return false
    }

    const { data: response } = await axios.post(
      props.urls.sendOtherRequirementByEmail,
      {
        otherRequirement: otherRequirement.value,
      }
    )

    customAlert(response)
    otherRequirement.value = ''
    localStorage.removeItem('otherRequirement')
    $('#otherRequirementModal').modal('hide')
  } catch (error) {
    console.error(error)
  }
}

const sendOtherRequirement = () => {
  const newServiceUrl = new URL(props.urls.newService)
  newServiceUrl.searchParams.append(
    'otrosRequerimientos',
    otherRequirement.value
  )
  window.location.href = newServiceUrl
}
</script>
